import React, { useState } from 'react'
import AddNewHealthConcern from './AddNewHealthConcern';

const HealthConcern = ({expandAll, data, setIsRecordSaved, ...props}) => {

  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenHealthConcern, setIsOpenHealthConcern] = useState(false);
  const [healthConcernID, setHealthConcernID] = useState();
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddHealthConcern = (ID) => {
    if(!isViewAllowed) return;
    setHealthConcernID(ID)
    setIsOpenHealthConcern(prev => !prev);
  }
  const CloseHealthConcern = () => {
    setIsOpenHealthConcern(false)
  }

  console.log("propsHealthConcern",data,healthConcernID)
  let PopupScreen = "";
  if (isOpenHealthConcern) {
      PopupScreen = <AddNewHealthConcern isOpenHealthConcern={isOpenHealthConcern} healthConcernID={healthConcernID} setIsRecordSaved={setIsRecordSaved} onClose={CloseHealthConcern} patientID={props?.patientID} // onDeleteHealthConcern={DeleteHealthConcern}  
       IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
      />
  }
  return (
    <>
    {PopupScreen}
    <div className='content-box '>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1'>
            <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Health Concern</p>
            {data?.length === 0 && <i className={`icon-dash-plus fs-19 ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddHealthConcern(null)}></i>}
        </div>
        {expandItems &&
          expandAll &&
        <div className="d-flex flex-column gap-2">
        {(data?.length > 0 ?
          <>
          {data.map(item => {
            return (
              // <div className=''>
              //   <p className='text validate-color'onClick={() => AddHealthConcern(item.PatientHealthConcernID)}>{item.DiagnosisCode}</p>
              //   <p className='px-1 text bg_light validation_message text-nowrap my-1'>{item.DiagnosisDescription}</p>
              //   <div className="d-flex justify-content-between align-items-center">
              //     <div className='d-flex align-items-center gap-1'>
              //       <p className='text font-m'>Onset Date:</p>
              //       <p className='text'>{item.OnsetDate}</p>
              //     </div>
              //     <p className='heading'>{item.Acuity}</p> {/* className='heading orange-clr'Mild */}
              //   </div>
              // </div>
              <div className='ar-dot'>
                  <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddHealthConcern(item.PatientHealthConcernID)}>{item.Notes}</p>
              </div>
          )})}
          {/* <ShowHideInActive/> */}
          </> :
        <div className="d-flex gap-1 align-items-center ">
          {/* <p className='text font-m light-clrs fst-italic'>Add Health Concern Note</p>
          <div className="ar-add-icon">
            <i className="icon-dash-plus"></i>
          </div> */}
        </div>
      )}
        {/* <div className="d-flex gap-1 align-items-center ">
          <p className='text font-m light-clrs fst-italic'>Add Health Concern Note</p>
          <div className="ar-add-icon">
            <i className="icon-dash-plus"></i>
          </div>
        </div>
        <div className='d-flex align-items-center gap-1'>
            <p className='text font-m'>Note: </p>
            <p className='heading validate-color'>XXXXXXXXXXXXXX</p>
        </div> */}
      </div>}
    </div>
    </>
  )
}

export default HealthConcern